import { useEffect } from 'react'

const MediaPermissionsChecker = () => {
  const checkMediaPermissions = async () => {
    try {
      const cameraPermission = await navigator.permissions.query({
        name: 'camera' as PermissionName,
      })
      const microphonePermission = await navigator.permissions.query({
        name: 'microphone' as PermissionName,
      })
      const isPrompt =
        cameraPermission.state === 'prompt' ||
        microphonePermission.state === 'prompt'

      setTimeout(() => {
        if (
          isPrompt ||
          cameraPermission.state === 'denied' ||
          microphonePermission.state === 'denied'
        ) {
          const zmmtgRoot = document.getElementById('zmmtg-root')
          if (zmmtgRoot) {
            let overlay = document.getElementById('zoom-overlay')
            if (!overlay) {
              overlay = document.createElement('div')
              overlay.id = 'zoom-overlay'
              overlay.style.position = 'fixed'
              overlay.style.top = '0'
              overlay.style.left = '0'
              overlay.style.width = '100vw'
              overlay.style.height = '100vh'
              overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
              overlay.style.zIndex = '999999'
              overlay.style.pointerEvents = 'none'

              zmmtgRoot.appendChild(overlay)
            }
          } else {
            console.warn('No se encontró zmmtg-root.')
          }
        }
      }, 100)

      await navigator.mediaDevices.getUserMedia({ video: true, audio: true })

      setTimeout(() => {
        const existingOverlay = document.getElementById('zoom-overlay')
        if (existingOverlay) {
          existingOverlay.remove()
        }
      }, 100)
    } catch (error) {
      console.error('Error en permisos:', error)

      setTimeout(() => {
        const existingOverlay = document.getElementById('zoom-overlay')
        if (existingOverlay) {
          existingOverlay.remove()
        }
      }, 100)
    }
  }

  useEffect(() => {
    checkMediaPermissions()
  }, [])

  return null
}

export default MediaPermissionsChecker
